/**
 * Browser Supabase client — used ONLY for auth (sign in/out, session). All data
 * reads/writes go through the ingestion server (worker/) with the access token, so the
 * browser never touches the tables directly and RLS stays locked.
 */
import { createClient } from '@supabase/supabase-js';
import { env } from './env';

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
